import { render, staticRenderFns } from "./EditDict.vue?vue&type=template&id=8de85244&scoped=true"
import script from "./EditDict.vue?vue&type=script&lang=js"
export * from "./EditDict.vue?vue&type=script&lang=js"
import style0 from "./EditDict.vue?vue&type=style&index=0&id=8de85244&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de85244",
  null
  
)

export default component.exports